import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { SharedModule } from '../shared.module';

@Component({
  standalone: true,
  selector: 'icu-loading-checkbox',
  templateUrl: 'loading-checkbox.component.html',
  imports: [SharedModule]
})
export class LoadingCheckboxComponent {
  @Input() checked?: boolean;
  @Input() loading?: boolean;
  @Input() disabled?: boolean;
  @Input() color = 'accent';

  @Output() changed = new EventEmitter<MatCheckboxChange>();
  @Output() checkedChange = new EventEmitter<boolean>();

  onChanged(change: MatCheckboxChange): void {
    this.changed.emit(change);
  }
}
